// extracted by mini-css-extract-plugin
module.exports = {"formToggle":"form-toggle_formToggle__3dt67","isSelected":"form-toggle_isSelected__fGDj7","outOfStock":"form-toggle_outOfStock__5_1_A"};